import React from 'react';
import headerImage from './assets/header.jpg';
import { professionalSummary } from './ResumeData';

export default function Home() {
  return (
    <main className="Home">
      <h2>Welcome to My Portfolio!</h2>
      <h4>Darius Quick - Software Developer</h4>
      <p><strong>Work Authorization:</strong> U.S. Citizen</p>
      <section style={{ maxWidth: '900px', margin: '1.5rem auto', textAlign: 'left' }}>
        <h3>Professional Summary</h3>
        <p>{professionalSummary}</p>
      </section>
      <img src={headerImage} alt="Darius Quick" style={{ width: 'min(320px, 80%)', aspectRatio: '3 / 4', objectFit: 'cover' }} />
    </main>
  );
}
